import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { brandService } from '@/services/brandService';
import type { UpdateBrandSettingsInput } from '@/types/brand';

// Hook to get brand settings (singleton)
export function useBrandSettings() {
  return useQuery({
    queryKey: ['brandSettings'],
    queryFn: () => brandService.getBrandSettings(),
  });
}

// Hook to update brand settings
export function useUpdateBrandSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateBrandSettingsInput) => brandService.updateBrandSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['brandSettings'] });
    },
  });
}

// Legacy hook aliases for backward compatibility
// @deprecated Use useBrandSettings instead
export const useCurrentBrand = useBrandSettings;
